import React from 'react'
import AppContext from 'AppContext'
import { featureEnabled, env } from 'components/Helpers'
import { NotEnabledPage } from 'scenes/NotEnabled'

// Capacity alerting per location (location-monitor), reached from the
// "Manage Alerts" button on the Locations page
const LocationMonitor = () => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index locations'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  if (!featureEnabled('locationMonitor', id)) {
    return (<NotEnabledPage />)
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index locations'>
      {/* eslint-disable-next-line */}
      <h1></h1>
      <cl-location-monitor
        mountPath={`/operators/${id}/location-monitor`}
        apiHost={`https://location-monitor.${env()}.credlock.net`}
        operatorId={id}
        token={token}
      />
    </div>
  )
}

export default LocationMonitor
